import { useAppDispatch } from 'store/hooks';
import mediaSelectors from '../selectors';
import mediaActions from '../actions';
import { useEffect } from 'react';

const useGetManageLibrary = (isLazy = false) => {
  const dispatch = useAppDispatch();
  const data = mediaSelectors.getDataLibraryMedia();

  const mutate = (path: string, keySearch?: string) => {
    dispatch(mediaActions.getListLibraryMedia.fetch({ path, keySearch }));
  };

  useEffect(() => {
    if (!isLazy) {
      mutate(' ', undefined);
    }
  }, []);

  return [data, mutate] as const;
};

export default useGetManageLibrary;
